import React from 'react';
import { SidebarContainer, NavList, NavItem, NavLabel, CollapseButton } from './sidebar.styled';
import {
  LayoutDashboard,
  FileText,
  ClipboardList,
  Users,
  Boxes,
  Workflow,
  File,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/admin' },
  { id: 'pdfs', label: 'Pdfs', icon: File, path: '/admin/pdfs' },
  { id: 'procedures', label: 'Procedures', icon: FileText, path: '/admin/procedures' },
  // { id: 'applications', label: 'Applications', icon: ClipboardList, path: '/admin/applications' },
  { id: 'users', label: 'Users', icon: Users, path: '/admin/users' },
  { id: 'clusters', label: 'Clusters', icon: Boxes, path: '/admin/clusters' },
  { id: 'clusterFlows', label: 'Cluster Flows', icon: Workflow, path: '/admin/clusterFlows' },
];

const Sidebar = ({ isCollapsed, onToggleCollapse, activeTab }) => {
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <SidebarContainer isCollapsed={isCollapsed}>
      <NavList>
        {menuItems.map((item) => {
          const color = activeTab === item.id ? '#6366f1' : '#1f2937';
          return (
            <NavItem
              key={item.id}
              isActive={activeTab === item.id}
              isCollapsed={isCollapsed}
              onClick={() => handleNavigation(item.path)}
            >
              <item.icon size={20} style={{ color }} />
              <NavLabel isActive={activeTab === item.id} isCollapsed={isCollapsed}>
                {item.label}
              </NavLabel>
            </NavItem>
          );
        })}
      </NavList>
      <CollapseButton isCollapsed={isCollapsed} onClick={onToggleCollapse}>
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </CollapseButton>
    </SidebarContainer>
  );
};

export default Sidebar;
